import React, { memo } from "react";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import {
	formatMailboxListDate,
	getMailboxFolderItemByApiFolder,
	getMailboxIntentItem,
	getMailboxMessageDetailPath,
	getMessageDate,
	getMessageFromParty,
	getMessageId,
	getReportMailboxMessage,
	MAILBOX_INTENT_DATA_BREACH_INCIDENT,
	MAILBOX_INTENT_DATA_SUBJECT_REQUEST,
} from "src/modules/mailer/helpers";

const RelatedMailboxMessage = ({ t, report, variant = "request" }) => {
	const message = getReportMailboxMessage(report);

	if (!message) {
		return null;
	}

	const messageId = getMessageId(message);
	const party = getMessageFromParty(message);
	const sender =
		party.display ||
		message.from_address ||
		message.fromAddress ||
		t("Unknown sender");
	const receivedDate = formatMailboxListDate(getMessageDate(message));
	const folderItem = getMailboxFolderItemByApiFolder(
		message.folder || message.imap_folder || message.imapFolder
	);
	const caseId = report?.case_id || report?.caseId;
	const intentCode = variant === "incident"
		? MAILBOX_INTENT_DATA_BREACH_INCIDENT
		: MAILBOX_INTENT_DATA_SUBJECT_REQUEST;
	const casePath = caseId
		? getMailboxIntentItem(intentCode)?.caseDetailPath?.(caseId)
		: null;
	const emailsPath = casePath
		? {
				pathname: casePath,
				search: "?tab=emails",
				state: {
					mailboxFolderPath: folderItem?.path,
				},
		  }
		: null;
	const detailPath = emailsPath || (messageId
		? {
				pathname: getMailboxMessageDetailPath(messageId),
				state: {
					mailboxFolderPath: folderItem?.path,
				},
		  }
		: null);
	const leadKey =
		variant === "incident"
			? "This incident was automatically created from an email sent by"
			: "This request was automatically created from an email sent by";

	return (
		<div className="mailbox-created-from-email">
			<div
				className="mailbox-created-from-email__icon"
				aria-hidden="true"
			>
				<i className="mdi mdi-email" />
			</div>

			<div className="mailbox-created-from-email__body">
				<div className="mailbox-created-from-email__title">
					{t("Created from email")}
				</div>
				<p className="mailbox-created-from-email__description">
					{t(leadKey)}
					{" "}
					<strong>{sender}</strong>
					{receivedDate ? ` ${t("on {{date}}", { date: receivedDate })}` : ""}
					{"."}
				</p>
			</div>

			{detailPath ? (
				<Link
					to={detailPath}
					className="mailbox-created-from-email__link"
				>
					{t("View email thread")}
					<i className="ri-arrow-right-line" aria-hidden="true" />
				</Link>
			) : null}
		</div>
	);
};

export default withNamespaces()(memo(RelatedMailboxMessage));
